import LocaleNavigation from './LocaleNavigation';

export default LocaleNavigation;
